import React from 'react';
import LargeWidthContainer from '../../../Layout/Containers/LargeWidthContainer';
import { StrapiCoverImageComponent } from '../../MediaComponent/MediaComponent';
import { BlocksRenderer } from '@strapi/blocks-react-renderer';
import Link from 'next/link';
import styles from './renderSolutions.module.scss';
import ReadMore from '../../ReadMore/ReadMoreComponent';
import InsuranceContactComponent from '../../../Contact/InsuranceContactComponent';
import BreadcrumbsComponent from '../../../Breadcrumbs/BreadcrumbsComponent';
import SolutionCards from '../SolutionCards/SolutionCards';
import TargetGroupCards from '../TargetGroupCards/TargetGroupCards';

const RenderCoverImageSection = ({ coverImage }: any) => {
    if (!coverImage) {
        return null;
    }
    return (
        <LargeWidthContainer>
            <StrapiCoverImageComponent
                strapiImage={coverImage.picture}
                styles={{ width: '100%', height: '476px' }}
                className={styles.fullCoverImage}
            >
                <div className={styles.cover}>
                    <BlocksRenderer content={coverImage.paragraph}></BlocksRenderer>
                    <div className={styles.links}>
                        <Link
                            href="#target-groups"
                            className={`button-link-inverted`}
                            scroll={false}
                        >
                            <span>Who we serve &#10132;</span>
                        </Link>
                        <Link href="#contact-banner" className={`button-link`} scroll={false}>
                            <span>Contact us &#10132;</span>
                        </Link>
                    </div>
                </div>
            </StrapiCoverImageComponent>
        </LargeWidthContainer>
    );
};

const RenderIntroductionSection = ({ introduction }: any) => {
    if (!introduction) {
        return null;
    }
    return (
        <LargeWidthContainer>
            <div className={styles.introduction}>
                <ReadMore height={420}>
                    <BlocksRenderer content={introduction.paragraph}></BlocksRenderer>
                </ReadMore>
            </div>
        </LargeWidthContainer>
    );
};

const RenderBenefitsSection = ({ benefits }: any) => {
    if (!benefits) {
        return null;
    }
    return (
        <LargeWidthContainer>
            <div className={styles.benefits}>
                <BlocksRenderer content={benefits.paragraph}></BlocksRenderer>
            </div>
        </LargeWidthContainer>
    );
};

const crumbs = [
    {
        url: '',
        name: 'Products',
    },
    {
        url: '/solutions',
        name: 'Insurance Solutions',
    },
];

const RenderSolutions = (page: any) => {
    if (!page.content) {
        return null;
    } else {
        return (
            <>
                <LargeWidthContainer>
                    <BreadcrumbsComponent crumbs={crumbs} />
                </LargeWidthContainer>
                <RenderCoverImageSection
                    coverImage={page.content['coverImage']}
                ></RenderCoverImageSection>
                <RenderIntroductionSection
                    introduction={page.content['introduction']}
                ></RenderIntroductionSection>
                <RenderBenefitsSection benefits={page.content['benefits']}></RenderBenefitsSection>
                <SolutionCards solutions={page.content['solutions']}></SolutionCards>
                <div id="contact-banner" className={styles.contact}>
                    <InsuranceContactComponent />
                </div>
                <TargetGroupCards
                    targetHeader={page.content['targetHeader']}
                    targets={page.content['targets']}
                ></TargetGroupCards>
            </>
        );
    }
};

export default RenderSolutions;
